import SUBSCRIPTION_TIERS from 'ui-forms-editor-automation-lib/constants/SUBSCRIPTION_TIERS';
const ENTERPRISE = 'workflows-contextual-marketing-enterprise';
const PRO = 'workflows-contextual-marketing-pro';
const STARTER = 'workflows-contextual-marketing-starter';
/*const FREE = 'workflows-contextual-marketing-free';*/

const getSubscriptionTier = scopes => {
  if (scopes.includes(ENTERPRISE)) {
    return SUBSCRIPTION_TIERS.ENTERPRISE;
  }
  if (scopes.includes(PRO)) {
    return SUBSCRIPTION_TIERS.PRO;
  }
  if (scopes.includes(STARTER)) {
    return SUBSCRIPTION_TIERS.STARTER;
  }
  return SUBSCRIPTION_TIERS.FREE;
};
export default getSubscriptionTier;